// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placement-shell-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
}

.placement-shell-title h2 {
    margin-bottom: 4px;
}

.placement-shell-subtitle {
    font-size: 18px;
    font-weight: 600;
    color: #344054;
    margin: 0;
}

.placement-back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border: 1px solid #d7dde8;
    border-radius: 6px;
    color: #667085;
    background: #fff;
    font-size: 12px;
    text-decoration: none;
}

.placement-pill-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 18px;
    border-radius: 10px;
    background: #eef4fb;
    margin-bottom: 24px;
}

.placement-pill-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 38px;
    padding: 8px 18px;
    border: 1px solid #6f7785;
    border-radius: 999px;
    background: #fff;
    color: #293241;
    font-size: 13px;
    line-height: 1;
    text-decoration: none;
    white-space: nowrap;
}

.placement-pill-link.active {
    border-color: #123d66;
    background: #123d66;
    color: #fff;
}

.placement-section-title {
    font-size: 26px;
    font-weight: 700;
    color: #22304a;
    margin-bottom: 16px;
}

.placement-subtabs {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0;
    border: 1px solid #6fa7ea;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 18px;
}

.placement-subtab {
    border: 0;
    background: #fff;
    color: #2b5c95;
    padding: 9px 14px;
    font-size: 13px;
}

.placement-subtab + .placement-subtab {
    border-left: 1px solid #6fa7ea;
}

.placement-subtab.active {
    background: #1f69c8;
    color: #fff;
}

.placement-card-table {
    border: 1px solid #edf1f6;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
}

.placement-card-table table {
    margin-bottom: 0;
}

.placement-card-table thead th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #22304a;
    background: #f8fafc;
    border-bottom: 1px solid #edf1f6;
    white-space: nowrap;
}

.placement-card-table tbody td {
    font-size: 13px;
    color: #344054;
    white-space: nowrap;
}

/* —— Placement Focus (prototype match) —— */
.pf-subtitle {
    color: #667085;
    font-size: 13px;
    margin-bottom: 18px;
}

.pf-stat-row {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 20px;
}

.pf-stat-card {
    background: #fff;
    border: 1px solid #e6ebf2;
    border-left-width: 4px;
    border-radius: 8px;
    padding: 14px 16px;
}

.pf-stat-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #667085;
}

.pf-stat-value {
    font-size: 28px;
    font-weight: 700;
    color: #123d66;
    line-height: 1.15;
    margin: 4px 0;
}

.pf-stat-value span {
    font-size: 16px;
    color: #98a2b3;
    font-weight: 600;
}

.pf-stat-blurb {
    font-size: 12px;
    color: #98a2b3;
}

.pf-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 320px;
    gap: 16px;
    align-items: start;
}

.pf-search {
    position: relative;
    margin-bottom: 14px;
}

.pf-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #98a2b3;
    font-size: 16px;
}

.pf-search input {
    width: 100%;
    border: 1px solid #d0d5dd;
    border-radius: 8px;
    padding: 10px 12px 10px 34px;
    font-size: 13px;
}

.pf-leak-block {
    background: #fff;
    border: 1px solid #e6ebf2;
    border-radius: 10px;
    margin-bottom: 12px;
    overflow: hidden;
}

.pf-leak-header {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    border: 0;
    background: #f8fafc;
    text-align: left;
}

.pf-leak-pill {
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    border-radius: 999px;
    padding: 3px 10px;
}

.pf-leak-title {
    font-weight: 700;
    color: #22304a;
    font-size: 14px;
}

.pf-leak-meta {
    margin-left: auto;
    font-size: 12px;
    color: #667085;
}

.pf-leak-chevron {
    color: #98a2b3;
    font-size: 12px;
}

.pf-company-card {
    display: flex;
    gap: 12px;
    padding: 14px;
    border-top: 1px solid #edf1f6;
}

.pf-avatar {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    flex-shrink: 0;
}

.pf-company-body {
    flex: 1 1;
    min-width: 0;
}

.pf-company-top {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: flex-start;
}

.pf-company-name {
    font-weight: 700;
    color: #22304a;
    text-decoration: none;
    font-size: 14px;
}

.pf-company-meta {
    font-size: 12px;
    color: #667085;
    margin: 4px 0 8px;
}

.pf-never-visited {
    color: #d92d20;
    font-weight: 600;
}

.pf-add-btn {
    border: 1px solid #1f69c8;
    background: #fff;
    color: #1f69c8;
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.pf-add-btn.added {
    border-color: #12b76a;
    color: #12b76a;
    background: #ecfdf3;
}

.pf-seniority-bar {
    display: flex;
    height: 6px;
    border-radius: 999px;
    overflow: hidden;
    background: #eef2f6;
    margin-bottom: 6px;
}

.pf-seniority-bar span {
    display: block;
    height: 100%;
}

.pf-seniority-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 11px;
    color: #667085;
}

.pf-seniority-legend i {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 2px;
    margin-right: 4px;
}

.pf-sidebar {
    background: #fff;
    border: 1px solid #e6ebf2;
    border-radius: 10px;
    padding: 14px;
    position: sticky;
    top: 12px;
}

.pf-sidebar-head {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 12px;
}

.pf-sidebar-title {
    font-size: 16px;
    font-weight: 700;
    color: #22304a;
}

.pf-sidebar-sub {
    font-size: 12px;
    color: #667085;
}

.pf-btn-export,
.pf-btn-primary {
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 600;
}

.pf-btn-export {
    border: 1px solid #d0d5dd;
    background: #fff;
    color: #344054;
}

.pf-btn-primary {
    border: 0;
    background: #1f69c8;
    color: #fff;
}

.pf-pick {
    margin-bottom: 12px;
}

.pf-pick label {
    display: block;
    font-size: 12px;
    color: #667085;
    margin-bottom: 4px;
}

.pf-pick input {
    width: 100%;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 12px;
}

.pf-pick-results {
    border: 1px solid #e6ebf2;
    border-radius: 6px;
    max-height: 140px;
    overflow: auto;
    margin-top: 4px;
}

.pf-pick-results button {
    display: block;
    width: 100%;
    text-align: left;
    border: 0;
    background: #fff;
    padding: 8px 10px;
    font-size: 12px;
    border-bottom: 1px solid #f2f4f7;
}

.pf-focus-list {
    max-height: calc(5 * 84px); /* ~5 company rows */
    overflow-y: auto;
}

.pf-focus-item {
    display: flex;
    gap: 10px;
    padding: 10px 0;
    border-top: 1px solid #edf1f6;
}

.pf-focus-num {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #eef4fb;
    color: #123d66;
    font-size: 11px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.pf-focus-name-row {
    display: flex;
    justify-content: space-between;
    gap: 8px;
}

.pf-remove {
    border: 0;
    background: transparent;
    color: #98a2b3;
    font-size: 18px;
    line-height: 1;
    padding: 0 2px;
}

.pf-tag {
    display: inline-block;
    margin-top: 4px;
    font-size: 11px;
    color: #475467;
    background: #f2f4f7;
    border-radius: 999px;
    padding: 2px 8px;
}

.pf-watchlist-link {
    display: inline-block;
    margin-top: 6px;
    font-size: 12px;
    color: #1f69c8;
    text-decoration: none;
}

.pf-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pf-modal {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    min-width: 320px;
    max-width: 420px;
}

.pf-modal h4 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 8px;
}

.pf-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
}

@media (max-width: 992px) {
    .pf-stat-row {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .pf-layout {
        grid-template-columns: 1fr;
    }
    .pf-sidebar {
        position: static;
    }
}

/* —— Matrix (AHLI / SPM) —— */
.mx-filter-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}

.mx-filter-label {
    font-size: 12px;
    color: #667085;
    font-weight: 600;
}

.mx-filter-pill {
    border: 1px solid #d0d5dd;
    background: #fff;
    color: #344054;
    border-radius: 999px;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 600;
}

.mx-filter-pill.sm {
    padding: 2px 8px;
    font-size: 11px;
}

.mx-filter-pill.active {
    background: #123d66;
    border-color: #123d66;
    color: #fff;
}

.mx-chart {
    cursor: crosshair;
    position: relative;
}

.mx-chart-inner {
    position: relative;
    width: 100%;
    height: 100%;
}

.mx-chart-col {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}

.mx-chart-row {
    display: flex;
    align-items: stretch;
    flex: 1 1 auto;
    min-height: 0;
}

.mx-chart-plot {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    height: 100%;
}

.mx-outlier-lane-top-row {
    display: flex;
    align-items: stretch;
    margin-bottom: 8px;
}

.mx-outlier-lane-top {
    display: flex;
    align-items: stretch;
    flex: 1 1 auto;
}

.mx-outlier-lane-top-spacer {
    flex: 0 0 82px;
    width: 82px;
}

.mx-outlier-label-vert {
    display: flex;
    align-items: center;
    justify-content: center;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #667085;
    padding-right: 6px;
    margin-right: 8px;
    border-right: 1px solid #cbd5e1;
    flex-shrink: 0;
}

.mx-outlier-dots-row {
    position: relative;
    flex: 1 1 auto;
    height: 100%;
}

.mx-outlier-dot-h {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 1.5px solid;
    border-radius: 50%;
    cursor: pointer;
}

.mx-outlier-lane {
    position: relative;
    flex: 0 0 72px;
    width: 72px;
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid #cbd5e1;
}

.mx-outlier-dots {
    position: relative;
    width: 100%;
}

.mx-outlier-dot {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border: 1.5px solid;
    border-radius: 50%;
    cursor: pointer;
}

.mx-outlier-label {
    text-align: center;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #667085;
    padding-top: 6px;
    border-top: 1px solid #cbd5e1;
}

.mx-hover-wrap {
    position: absolute;
    z-index: 5;
    pointer-events: none;
    max-width: min(280px, calc(100% - 32px));
}

.mx-hover-card {
    background: #fff;
    border: 1px solid #e6ebf2;
    border-radius: 12px;
    box-shadow: 0 10px 28px rgba(16, 24, 40, 0.16);
    padding: 14px 16px;
    min-width: 220px;
}

.mx-hover-name {
    font-size: 14px;
    font-weight: 700;
    color: #1a2332;
    margin-bottom: 8px;
    line-height: 1.3;
}

.mx-hover-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 12px;
}

.mx-hover-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    color: #fff;
}

.mx-hover-tier {
    background: #475467;
}

.mx-hover-fields {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.mx-hover-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    font-size: 12px;
}

.mx-hover-row span {
    color: #667085;
}

.mx-hover-row strong {
    color: #1a2332;
    font-weight: 700;
}

.mx-counts-head,
.mx-list-head {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #667085;
    margin-bottom: 8px;
}

.mx-counts-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.mx-count-card {
    text-align: left;
    background: #fff;
    border: 1px solid #e6ebf2;
    border-left-width: 4px;
    border-radius: 8px;
    padding: 10px 12px;
}

.mx-count-card.active {
    box-shadow: 0 0 0 2px rgba(18, 61, 102, 0.15);
}

.mx-count-value {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
}

.mx-count-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.03em;
    color: #667085;
    margin-top: 2px;
}

/* —— Listing (prototype-aligned) —— */
.pa-listing-wrap {
    overflow: visible !important;
    height: auto !important;
}

.pa-listing-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
}

.pa-listing-title {
    font-size: 26px;
    font-weight: 700;
    color: #1a2332;
    margin: 0 0 6px;
}

.pa-listing-sub {
    font-size: 13px;
    color: #8a94a6;
    margin: 0;
}

.pa-btn-filters {
    border: 1px solid #2f6fed;
    background: #2f6fed;
    color: #fff;
    border-radius: 8px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
}

.pa-filter-card {
    background: #fff;
    border: 1px solid #e6ebf2;
    border-radius: 12px;
    padding: 16px 18px;
    margin-bottom: 18px;
}

.pa-filter-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 14px;
}

.pa-filter-grid-6 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.pa-filter-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 0;
}

.pa-filter-field > span {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #8a94a6;
}

.pa-listing-meta {
    font-size: 13px;
    color: #667085;
    margin-bottom: 12px;
}

.pa-table-wrap {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
}

.pa-table {
    margin-bottom: 0;
    width: 100%;
    min-width: 980px;
    border-collapse: separate;
    border-spacing: 0;
}

.pa-table thead th {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #8a94a6;
    border-bottom: 1px solid #e6ebf2;
    white-space: nowrap;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 2;
    padding: 10px 12px;
}

.pa-table tbody td {
    font-size: 13px;
    color: #293241;
    border-bottom: 1px solid #eef1f6;
    vertical-align: middle;
    padding: 14px 12px;
    background: #fff;
}

.pa-table tbody tr:last-child td {
    border-bottom: 0;
}

.pa-inst-link {
    font-weight: 600;
    color: #2f6fed;
    text-decoration: none;
}

.pa-inst-link:hover {
    text-decoration: underline;
}

.pa-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.3;
    white-space: nowrap;
}

.pa-badge-green {
    background: #e8f8ef;
    color: #1b7a45;
}

.pa-badge-yellow {
    background: #fff6db;
    color: #9a6b00;
}

.pa-badge-gray {
    background: #eef1f6;
    color: #667085;
}

.pa-badge-cyan {
    background: #e6f7fb;
    color: #0a7a8f;
}

.pa-badge-blue {
    background: #e8f0fe;
    color: #1a56db;
}

.pa-badge-orange {
    background: #fff0e6;
    color: #c05600;
}

.pa-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    white-space: nowrap;
}

.pa-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
}

.pa-dot-green {
    background: #22a06b;
}

.pa-dot-red {
    background: #e5484d;
}

.pa-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    min-width: 280px;
}

.pa-btn-ghost {
    border: 1px solid #d0d5dd;
    background: #fff;
    color: #293241;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.pa-btn-primary-ghost {
    border-color: #2f6fed;
    color: #2f6fed;
}

.pa-menu-wrap {
    position: relative;
    flex-shrink: 0;
}

.pa-btn-icon {
    border: 1px solid #e6ebf2;
    background: #fff;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    font-size: 16px;
    line-height: 1;
    color: #667085;
}

.pa-menu {
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
    z-index: 40;
    min-width: 220px;
    background: #fff;
    border: 1px solid #e6ebf2;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
    padding: 6px;
    display: flex;
    flex-direction: column;
}

.pa-menu button {
    border: 0;
    background: transparent;
    text-align: left;
    padding: 8px 10px;
    border-radius: 6px;
    font-size: 13px;
    color: #293241;
}

.pa-menu button:hover {
    background: #f5f7fb;
}

@media (max-width: 1100px) {
    .pa-filter-grid,
    .pa-filter-grid-6 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 640px) {
    .pa-listing-head {
        flex-direction: column;
    }
    .pa-filter-grid,
    .pa-filter-grid-6 {
        grid-template-columns: 1fr;
    }
}

/* —— Insights (prototype-aligned) —— */
.pi-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;
}

.pi-meta {
    font-size: 12px;
    color: #8a94a6;
}

.pi-watchlist-btn {
    display: inline-flex;
    align-items: center;
    border: 1px solid #d0d5dd;
    border-radius: 8px;
    padding: 7px 12px;
    font-size: 12px;
    font-weight: 600;
    color: #475467;
    text-decoration: none;
    background: #fff;
}

.pi-stat-row {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 28px;
}

.pi-stat-card {
    background: #fff;
    border: 1px solid #e6ebf2;
    border-radius: 10px;
    padding: 14px 16px 16px;
    border-top-width: 3px;
}

.pi-accent-blue { border-top-color: #2f6fed; }
.pi-accent-yellow { border-top-color: #e8b339; }
.pi-accent-cyan { border-top-color: #36b9c5; }
.pi-accent-red { border-top-color: #e5484d; }
.pi-accent-green { border-top-color: #22a06b; }

.pi-stat-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #8a94a6;
    margin-bottom: 8px;
}

.pi-stat-value {
    font-size: 28px;
    font-weight: 700;
    color: #1a2332;
    line-height: 1.15;
}

.pi-stat-sub {
    margin-top: 6px;
    font-size: 12px;
    color: #667085;
    min-height: 18px;
}

.pi-section {
    margin-bottom: 28px;
}

.pi-section-head {
    margin-bottom: 12px;
}

.pi-section-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.pi-section-title {
    font-size: 18px;
    font-weight: 700;
    color: #1a2332;
    margin: 0;
}

.pi-section-sub {
    margin: 6px 0 0;
    font-size: 12px;
    color: #8a94a6;
}

.pi-count-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 28px;
    padding: 2px 10px;
    border-radius: 999px;
    background: #344054;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
}

.pi-count-pill-dark {
    background: #475467;
}

.pi-table-card {
    border: 1px solid #e6ebf2;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
}

.pi-table-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: #f2f4f7;
    font-size: 12px;
    font-weight: 600;
    color: #475467;
}

.pi-table-scroll {
    overflow: auto;
    max-height: 420px;
}

.pi-table-scroll-sm {
    max-height: 320px;
}

.pi-table {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
}

.pi-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #8a94a6;
    text-align: left;
    padding: 10px 12px;
    border-bottom: 1px solid #e6ebf2;
    white-space: nowrap;
}

.pi-table td {
    font-size: 13px;
    color: #293241;
    padding: 11px 12px;
    border-bottom: 1px solid #eef1f6;
    vertical-align: middle;
}

.pi-table tbody tr:last-child td {
    border-bottom: 0;
}

.pi-company-link {
    color: #2f6fed;
    font-weight: 600;
    text-decoration: none;
}

.pi-company-link:hover {
    text-decoration: underline;
}

.pi-strong {
    font-weight: 700;
}

.pi-inf-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: capitalize;
}

.pi-inf-high {
    background: #fce8e8;
    color: #c62828;
}

.pi-inf-med {
    background: #fff3e0;
    color: #e65100;
}

.pi-inf-low {
    background: #eef1f6;
    color: #667085;
}

.pi-sort-btn {
    border: 0;
    background: transparent;
    padding: 0;
    color: #2f6fed;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

@media (max-width: 1200px) {
    .pi-stat-row {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .pi-stat-row {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .pi-toolbar {
        flex-direction: column;
        align-items: flex-start;
    }
}

.pi-rankings-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
    background: #f5f6f8;
    border-radius: 12px;
    padding: 12px;
}

.pi-ranking-card {
    background: #fff;
    border: 1px solid #e6ebf2;
    border-radius: 10px;
    overflow: hidden;
    min-width: 0;
}

.pi-ranking-head {
    padding: 10px 12px;
    background: #eef1f6;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #475467;
    border-bottom: 1px solid #e6ebf2;
    line-height: 1.3;
    min-height: 44px;
    display: flex;
    align-items: center;
}

.pi-ranking-list {
    list-style: none;
    margin: 0;
    padding: 6px 0;
    max-height: 420px;
    overflow-y: auto;
}

.pi-ranking-list li {
    display: grid;
    grid-template-columns: 28px minmax(0, 1fr) auto;
    align-items: center;
    gap: 8px;
    padding: 7px 10px;
}

.pi-rank-num {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    color: #475467;
    background: #eef1f6;
}

.pi-rank-gold {
    background: #f5c542;
    color: #5c4300;
}

.pi-rank-silver {
    background: #c8ced6;
    color: #3d4654;
}

.pi-rank-bronze {
    background: #d4a574;
    color: #5c3a1a;
}

.pi-rank-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
}

.pi-rank-name .pi-company-link {
    font-size: 12px;
    font-weight: 600;
}

.pi-rank-value {
    font-size: 12px;
    font-weight: 700;
    color: #5b8def;
    white-space: nowrap;
}

@media (max-width: 1200px) {
    .pi-rankings-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .pi-rankings-grid {
        grid-template-columns: 1fr;
    }
}

/* —— Company Landscape (company_landscape_insights.html) —— */
.cl-landscape.max-1250 {
    max-width: 1250px;
    width: 100%;
}

.cl-landscape-banner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background: #212529;
    color: #fff;
    border-radius: 0.5rem;
    border-bottom: 4px solid #ffc107;
    padding: 1rem 1.25rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.cl-landscape-badge {
    display: inline-block;
    vertical-align: middle;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    color: #664d03;
    background: #fff3cd;
    border: 1px solid #ffecb5;
    border-radius: 999px;
    padding: 0.25rem 1rem;
}

.cl-landscape-section-title {
    margin-bottom: 1.5rem;
    padding-left: 0.85rem;
    border-left: 4px solid var(--bs-primary, #0d6efd);
}

.cl-landscape-card {
    position: relative;
    overflow: hidden;
    height: 100%;
    min-height: 148px;
    background: #fff;
    border: 0;
    border-top: 4px solid var(--bs-primary, #0d6efd);
    border-radius: 1rem;
    padding: 1.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.cl-landscape-card--primary {
    border-top-color: var(--bs-primary, #0d6efd);
}

.cl-landscape-card--info {
    border-top-color: var(--bs-info, #0dcaf0);
}

.cl-landscape-card--success {
    border-top-color: var(--bs-success, #198754);
}

.cl-landscape-card--warning {
    border-top-color: var(--bs-warning, #ffc107);
}

.cl-landscape .display-5 {
    font-size: 2.5rem;
    line-height: 1.15;
    color: #212529;
}

.cl-landscape-value-info {
    color: #055160;
}

.cl-landscape-card-label {
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
    text-transform: uppercase;
    color: #6c757d;
    opacity: 0.75;
    margin-bottom: 0;
}

.cl-landscape-hint {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 12px;
    font-weight: 500;
    color: #6c757d;
}

.cl-landscape-divider-vr {
    width: 0;
    height: calc(100% - 24px);
    min-height: 220px;
    border-right: 2px dashed #bebebe;
}

.cl-landscape-divider-hr {
    width: 100%;
    border-top: 2px dashed #bebebe;
}

.cl-landscape-relate {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    font-size: 13px;
    color: #6c757d;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.cl-landscape-num {
    font-family: var(--bs-font-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace);
    font-weight: 600;
    color: var(--bs-primary, #0d6efd);
}

`, "",{"version":3,"sources":["webpack://./src/features/admin/placement-analytics/placementAnalytics.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,MAAM;IACN,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,0BAA0B,EAAE,oBAAoB;IAChD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI;QACI,gDAAgD;IACpD;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,eAAe;AACnB;;AAEA,sCAAsC;AACtC;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;IAC7C,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;;QAEI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;;QAEI,0BAA0B;IAC9B;AACJ;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA,kBAAkB,yBAAyB,EAAE;AAC7C,oBAAoB,yBAAyB,EAAE;AAC/C,kBAAkB,yBAAyB,EAAE;AAC7C,iBAAiB,yBAAyB,EAAE;AAC5C,mBAAmB,yBAAyB,EAAE;;AAE9C;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;IACA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,8DAA8D;AAC9D;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,gCAAgC;IAChC,qBAAqB;IACrB,qBAAqB;IACrB,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,gDAAgD;IAChD,mBAAmB;IACnB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,mDAAmD;AACvD;;AAEA;IACI,yFAAyF;IACzF,gBAAgB;IAChB,iCAAiC;AACrC","sourcesContent":[".placement-shell-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.placement-shell-title h2 {\n    margin-bottom: 4px;\n}\n\n.placement-shell-subtitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #344054;\n    margin: 0;\n}\n\n.placement-back-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border: 1px solid #d7dde8;\n    border-radius: 6px;\n    color: #667085;\n    background: #fff;\n    font-size: 12px;\n    text-decoration: none;\n}\n\n.placement-pill-bar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    padding: 18px;\n    border-radius: 10px;\n    background: #eef4fb;\n    margin-bottom: 24px;\n}\n\n.placement-pill-link {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 38px;\n    padding: 8px 18px;\n    border: 1px solid #6f7785;\n    border-radius: 999px;\n    background: #fff;\n    color: #293241;\n    font-size: 13px;\n    line-height: 1;\n    text-decoration: none;\n    white-space: nowrap;\n}\n\n.placement-pill-link.active {\n    border-color: #123d66;\n    background: #123d66;\n    color: #fff;\n}\n\n.placement-section-title {\n    font-size: 26px;\n    font-weight: 700;\n    color: #22304a;\n    margin-bottom: 16px;\n}\n\n.placement-subtabs {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 0;\n    border: 1px solid #6fa7ea;\n    border-radius: 6px;\n    overflow: hidden;\n    margin-bottom: 18px;\n}\n\n.placement-subtab {\n    border: 0;\n    background: #fff;\n    color: #2b5c95;\n    padding: 9px 14px;\n    font-size: 13px;\n}\n\n.placement-subtab + .placement-subtab {\n    border-left: 1px solid #6fa7ea;\n}\n\n.placement-subtab.active {\n    background: #1f69c8;\n    color: #fff;\n}\n\n.placement-card-table {\n    border: 1px solid #edf1f6;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #fff;\n}\n\n.placement-card-table table {\n    margin-bottom: 0;\n}\n\n.placement-card-table thead th {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #22304a;\n    background: #f8fafc;\n    border-bottom: 1px solid #edf1f6;\n    white-space: nowrap;\n}\n\n.placement-card-table tbody td {\n    font-size: 13px;\n    color: #344054;\n    white-space: nowrap;\n}\n\n/* —— Placement Focus (prototype match) —— */\n.pf-subtitle {\n    color: #667085;\n    font-size: 13px;\n    margin-bottom: 18px;\n}\n\n.pf-stat-row {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 12px;\n    margin-bottom: 20px;\n}\n\n.pf-stat-card {\n    background: #fff;\n    border: 1px solid #e6ebf2;\n    border-left-width: 4px;\n    border-radius: 8px;\n    padding: 14px 16px;\n}\n\n.pf-stat-label {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #667085;\n}\n\n.pf-stat-value {\n    font-size: 28px;\n    font-weight: 700;\n    color: #123d66;\n    line-height: 1.15;\n    margin: 4px 0;\n}\n\n.pf-stat-value span {\n    font-size: 16px;\n    color: #98a2b3;\n    font-weight: 600;\n}\n\n.pf-stat-blurb {\n    font-size: 12px;\n    color: #98a2b3;\n}\n\n.pf-layout {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 320px;\n    gap: 16px;\n    align-items: start;\n}\n\n.pf-search {\n    position: relative;\n    margin-bottom: 14px;\n}\n\n.pf-search-icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #98a2b3;\n    font-size: 16px;\n}\n\n.pf-search input {\n    width: 100%;\n    border: 1px solid #d0d5dd;\n    border-radius: 8px;\n    padding: 10px 12px 10px 34px;\n    font-size: 13px;\n}\n\n.pf-leak-block {\n    background: #fff;\n    border: 1px solid #e6ebf2;\n    border-radius: 10px;\n    margin-bottom: 12px;\n    overflow: hidden;\n}\n\n.pf-leak-header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 14px;\n    border: 0;\n    background: #f8fafc;\n    text-align: left;\n}\n\n.pf-leak-pill {\n    color: #fff;\n    font-size: 11px;\n    font-weight: 700;\n    border-radius: 999px;\n    padding: 3px 10px;\n}\n\n.pf-leak-title {\n    font-weight: 700;\n    color: #22304a;\n    font-size: 14px;\n}\n\n.pf-leak-meta {\n    margin-left: auto;\n    font-size: 12px;\n    color: #667085;\n}\n\n.pf-leak-chevron {\n    color: #98a2b3;\n    font-size: 12px;\n}\n\n.pf-company-card {\n    display: flex;\n    gap: 12px;\n    padding: 14px;\n    border-top: 1px solid #edf1f6;\n}\n\n.pf-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.pf-company-body {\n    flex: 1;\n    min-width: 0;\n}\n\n.pf-company-top {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    align-items: flex-start;\n}\n\n.pf-company-name {\n    font-weight: 700;\n    color: #22304a;\n    text-decoration: none;\n    font-size: 14px;\n}\n\n.pf-company-meta {\n    font-size: 12px;\n    color: #667085;\n    margin: 4px 0 8px;\n}\n\n.pf-never-visited {\n    color: #d92d20;\n    font-weight: 600;\n}\n\n.pf-add-btn {\n    border: 1px solid #1f69c8;\n    background: #fff;\n    color: #1f69c8;\n    border-radius: 6px;\n    padding: 4px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.pf-add-btn.added {\n    border-color: #12b76a;\n    color: #12b76a;\n    background: #ecfdf3;\n}\n\n.pf-seniority-bar {\n    display: flex;\n    height: 6px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: #eef2f6;\n    margin-bottom: 6px;\n}\n\n.pf-seniority-bar span {\n    display: block;\n    height: 100%;\n}\n\n.pf-seniority-legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    font-size: 11px;\n    color: #667085;\n}\n\n.pf-seniority-legend i {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 2px;\n    margin-right: 4px;\n}\n\n.pf-sidebar {\n    background: #fff;\n    border: 1px solid #e6ebf2;\n    border-radius: 10px;\n    padding: 14px;\n    position: sticky;\n    top: 12px;\n}\n\n.pf-sidebar-head {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.pf-sidebar-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: #22304a;\n}\n\n.pf-sidebar-sub {\n    font-size: 12px;\n    color: #667085;\n}\n\n.pf-btn-export,\n.pf-btn-primary {\n    border-radius: 6px;\n    padding: 6px 12px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.pf-btn-export {\n    border: 1px solid #d0d5dd;\n    background: #fff;\n    color: #344054;\n}\n\n.pf-btn-primary {\n    border: 0;\n    background: #1f69c8;\n    color: #fff;\n}\n\n.pf-pick {\n    margin-bottom: 12px;\n}\n\n.pf-pick label {\n    display: block;\n    font-size: 12px;\n    color: #667085;\n    margin-bottom: 4px;\n}\n\n.pf-pick input {\n    width: 100%;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    padding: 8px 10px;\n    font-size: 12px;\n}\n\n.pf-pick-results {\n    border: 1px solid #e6ebf2;\n    border-radius: 6px;\n    max-height: 140px;\n    overflow: auto;\n    margin-top: 4px;\n}\n\n.pf-pick-results button {\n    display: block;\n    width: 100%;\n    text-align: left;\n    border: 0;\n    background: #fff;\n    padding: 8px 10px;\n    font-size: 12px;\n    border-bottom: 1px solid #f2f4f7;\n}\n\n.pf-focus-list {\n    max-height: calc(5 * 84px); /* ~5 company rows */\n    overflow-y: auto;\n}\n\n.pf-focus-item {\n    display: flex;\n    gap: 10px;\n    padding: 10px 0;\n    border-top: 1px solid #edf1f6;\n}\n\n.pf-focus-num {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: #eef4fb;\n    color: #123d66;\n    font-size: 11px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.pf-focus-name-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n}\n\n.pf-remove {\n    border: 0;\n    background: transparent;\n    color: #98a2b3;\n    font-size: 18px;\n    line-height: 1;\n    padding: 0 2px;\n}\n\n.pf-tag {\n    display: inline-block;\n    margin-top: 4px;\n    font-size: 11px;\n    color: #475467;\n    background: #f2f4f7;\n    border-radius: 999px;\n    padding: 2px 8px;\n}\n\n.pf-watchlist-link {\n    display: inline-block;\n    margin-top: 6px;\n    font-size: 12px;\n    color: #1f69c8;\n    text-decoration: none;\n}\n\n.pf-modal-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.35);\n    z-index: 1050;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.pf-modal {\n    background: #fff;\n    border-radius: 10px;\n    padding: 20px;\n    min-width: 320px;\n    max-width: 420px;\n}\n\n.pf-modal h4 {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 8px;\n}\n\n.pf-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 16px;\n}\n\n@media (max-width: 992px) {\n    .pf-stat-row {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n    .pf-layout {\n        grid-template-columns: 1fr;\n    }\n    .pf-sidebar {\n        position: static;\n    }\n}\n\n/* —— Matrix (AHLI / SPM) —— */\n.mx-filter-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n}\n\n.mx-filter-label {\n    font-size: 12px;\n    color: #667085;\n    font-weight: 600;\n}\n\n.mx-filter-pill {\n    border: 1px solid #d0d5dd;\n    background: #fff;\n    color: #344054;\n    border-radius: 999px;\n    padding: 4px 12px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.mx-filter-pill.sm {\n    padding: 2px 8px;\n    font-size: 11px;\n}\n\n.mx-filter-pill.active {\n    background: #123d66;\n    border-color: #123d66;\n    color: #fff;\n}\n\n.mx-chart {\n    cursor: crosshair;\n    position: relative;\n}\n\n.mx-chart-inner {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.mx-chart-col {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n}\n\n.mx-chart-row {\n    display: flex;\n    align-items: stretch;\n    flex: 1 1 auto;\n    min-height: 0;\n}\n\n.mx-chart-plot {\n    position: relative;\n    flex: 1 1 auto;\n    min-width: 0;\n    height: 100%;\n}\n\n.mx-outlier-lane-top-row {\n    display: flex;\n    align-items: stretch;\n    margin-bottom: 8px;\n}\n\n.mx-outlier-lane-top {\n    display: flex;\n    align-items: stretch;\n    flex: 1 1 auto;\n}\n\n.mx-outlier-lane-top-spacer {\n    flex: 0 0 82px;\n    width: 82px;\n}\n\n.mx-outlier-label-vert {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    writing-mode: vertical-rl;\n    transform: rotate(180deg);\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: #667085;\n    padding-right: 6px;\n    margin-right: 8px;\n    border-right: 1px solid #cbd5e1;\n    flex-shrink: 0;\n}\n\n.mx-outlier-dots-row {\n    position: relative;\n    flex: 1 1 auto;\n    height: 100%;\n}\n\n.mx-outlier-dot-h {\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border: 1.5px solid;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.mx-outlier-lane {\n    position: relative;\n    flex: 0 0 72px;\n    width: 72px;\n    margin-left: 10px;\n    padding-left: 10px;\n    border-left: 1px solid #cbd5e1;\n}\n\n.mx-outlier-dots {\n    position: relative;\n    width: 100%;\n}\n\n.mx-outlier-dot {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 1.5px solid;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.mx-outlier-label {\n    text-align: center;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: #667085;\n    padding-top: 6px;\n    border-top: 1px solid #cbd5e1;\n}\n\n.mx-hover-wrap {\n    position: absolute;\n    z-index: 5;\n    pointer-events: none;\n    max-width: min(280px, calc(100% - 32px));\n}\n\n.mx-hover-card {\n    background: #fff;\n    border: 1px solid #e6ebf2;\n    border-radius: 12px;\n    box-shadow: 0 10px 28px rgba(16, 24, 40, 0.16);\n    padding: 14px 16px;\n    min-width: 220px;\n}\n\n.mx-hover-name {\n    font-size: 14px;\n    font-weight: 700;\n    color: #1a2332;\n    margin-bottom: 8px;\n    line-height: 1.3;\n}\n\n.mx-hover-badges {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 12px;\n}\n\n.mx-hover-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 700;\n    color: #fff;\n}\n\n.mx-hover-tier {\n    background: #475467;\n}\n\n.mx-hover-fields {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.mx-hover-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n    font-size: 12px;\n}\n\n.mx-hover-row span {\n    color: #667085;\n}\n\n.mx-hover-row strong {\n    color: #1a2332;\n    font-weight: 700;\n}\n\n.mx-counts-head,\n.mx-list-head {\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #667085;\n    margin-bottom: 8px;\n}\n\n.mx-counts-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n}\n\n.mx-count-card {\n    text-align: left;\n    background: #fff;\n    border: 1px solid #e6ebf2;\n    border-left-width: 4px;\n    border-radius: 8px;\n    padding: 10px 12px;\n}\n\n.mx-count-card.active {\n    box-shadow: 0 0 0 2px rgba(18, 61, 102, 0.15);\n}\n\n.mx-count-value {\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 1.1;\n}\n\n.mx-count-label {\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    color: #667085;\n    margin-top: 2px;\n}\n\n/* —— Listing (prototype-aligned) —— */\n.pa-listing-wrap {\n    overflow: visible !important;\n    height: auto !important;\n}\n\n.pa-listing-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.pa-listing-title {\n    font-size: 26px;\n    font-weight: 700;\n    color: #1a2332;\n    margin: 0 0 6px;\n}\n\n.pa-listing-sub {\n    font-size: 13px;\n    color: #8a94a6;\n    margin: 0;\n}\n\n.pa-btn-filters {\n    border: 1px solid #2f6fed;\n    background: #2f6fed;\n    color: #fff;\n    border-radius: 8px;\n    padding: 8px 14px;\n    font-size: 13px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.pa-filter-card {\n    background: #fff;\n    border: 1px solid #e6ebf2;\n    border-radius: 12px;\n    padding: 16px 18px;\n    margin-bottom: 18px;\n}\n\n.pa-filter-grid {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 14px;\n}\n\n.pa-filter-grid-6 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.pa-filter-field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin: 0;\n}\n\n.pa-filter-field > span {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #8a94a6;\n}\n\n.pa-listing-meta {\n    font-size: 13px;\n    color: #667085;\n    margin-bottom: 12px;\n}\n\n.pa-table-wrap {\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: visible;\n}\n\n.pa-table {\n    margin-bottom: 0;\n    width: 100%;\n    min-width: 980px;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.pa-table thead th {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #8a94a6;\n    border-bottom: 1px solid #e6ebf2;\n    white-space: nowrap;\n    background: #fff;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    padding: 10px 12px;\n}\n\n.pa-table tbody td {\n    font-size: 13px;\n    color: #293241;\n    border-bottom: 1px solid #eef1f6;\n    vertical-align: middle;\n    padding: 14px 12px;\n    background: #fff;\n}\n\n.pa-table tbody tr:last-child td {\n    border-bottom: 0;\n}\n\n.pa-inst-link {\n    font-weight: 600;\n    color: #2f6fed;\n    text-decoration: none;\n}\n\n.pa-inst-link:hover {\n    text-decoration: underline;\n}\n\n.pa-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 8px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1.3;\n    white-space: nowrap;\n}\n\n.pa-badge-green {\n    background: #e8f8ef;\n    color: #1b7a45;\n}\n\n.pa-badge-yellow {\n    background: #fff6db;\n    color: #9a6b00;\n}\n\n.pa-badge-gray {\n    background: #eef1f6;\n    color: #667085;\n}\n\n.pa-badge-cyan {\n    background: #e6f7fb;\n    color: #0a7a8f;\n}\n\n.pa-badge-blue {\n    background: #e8f0fe;\n    color: #1a56db;\n}\n\n.pa-badge-orange {\n    background: #fff0e6;\n    color: #c05600;\n}\n\n.pa-status {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    white-space: nowrap;\n}\n\n.pa-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    display: inline-block;\n    flex-shrink: 0;\n}\n\n.pa-dot-green {\n    background: #22a06b;\n}\n\n.pa-dot-red {\n    background: #e5484d;\n}\n\n.pa-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: nowrap;\n    min-width: 280px;\n}\n\n.pa-btn-ghost {\n    border: 1px solid #d0d5dd;\n    background: #fff;\n    color: #293241;\n    border-radius: 8px;\n    padding: 6px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.pa-btn-primary-ghost {\n    border-color: #2f6fed;\n    color: #2f6fed;\n}\n\n.pa-menu-wrap {\n    position: relative;\n    flex-shrink: 0;\n}\n\n.pa-btn-icon {\n    border: 1px solid #e6ebf2;\n    background: #fff;\n    border-radius: 8px;\n    width: 32px;\n    height: 32px;\n    font-size: 16px;\n    line-height: 1;\n    color: #667085;\n}\n\n.pa-menu {\n    position: absolute;\n    right: 0;\n    top: calc(100% + 4px);\n    z-index: 40;\n    min-width: 220px;\n    background: #fff;\n    border: 1px solid #e6ebf2;\n    border-radius: 10px;\n    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);\n    padding: 6px;\n    display: flex;\n    flex-direction: column;\n}\n\n.pa-menu button {\n    border: 0;\n    background: transparent;\n    text-align: left;\n    padding: 8px 10px;\n    border-radius: 6px;\n    font-size: 13px;\n    color: #293241;\n}\n\n.pa-menu button:hover {\n    background: #f5f7fb;\n}\n\n@media (max-width: 1100px) {\n    .pa-filter-grid,\n    .pa-filter-grid-6 {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 640px) {\n    .pa-listing-head {\n        flex-direction: column;\n    }\n    .pa-filter-grid,\n    .pa-filter-grid-6 {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* —— Insights (prototype-aligned) —— */\n.pi-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 18px;\n}\n\n.pi-meta {\n    font-size: 12px;\n    color: #8a94a6;\n}\n\n.pi-watchlist-btn {\n    display: inline-flex;\n    align-items: center;\n    border: 1px solid #d0d5dd;\n    border-radius: 8px;\n    padding: 7px 12px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #475467;\n    text-decoration: none;\n    background: #fff;\n}\n\n.pi-stat-row {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 12px;\n    margin-bottom: 28px;\n}\n\n.pi-stat-card {\n    background: #fff;\n    border: 1px solid #e6ebf2;\n    border-radius: 10px;\n    padding: 14px 16px 16px;\n    border-top-width: 3px;\n}\n\n.pi-accent-blue { border-top-color: #2f6fed; }\n.pi-accent-yellow { border-top-color: #e8b339; }\n.pi-accent-cyan { border-top-color: #36b9c5; }\n.pi-accent-red { border-top-color: #e5484d; }\n.pi-accent-green { border-top-color: #22a06b; }\n\n.pi-stat-label {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #8a94a6;\n    margin-bottom: 8px;\n}\n\n.pi-stat-value {\n    font-size: 28px;\n    font-weight: 700;\n    color: #1a2332;\n    line-height: 1.15;\n}\n\n.pi-stat-sub {\n    margin-top: 6px;\n    font-size: 12px;\n    color: #667085;\n    min-height: 18px;\n}\n\n.pi-section {\n    margin-bottom: 28px;\n}\n\n.pi-section-head {\n    margin-bottom: 12px;\n}\n\n.pi-section-title-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.pi-section-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #1a2332;\n    margin: 0;\n}\n\n.pi-section-sub {\n    margin: 6px 0 0;\n    font-size: 12px;\n    color: #8a94a6;\n}\n\n.pi-count-pill {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 28px;\n    padding: 2px 10px;\n    border-radius: 999px;\n    background: #344054;\n    color: #fff;\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.pi-count-pill-dark {\n    background: #475467;\n}\n\n.pi-table-card {\n    border: 1px solid #e6ebf2;\n    border-radius: 12px;\n    overflow: hidden;\n    background: #fff;\n}\n\n.pi-table-banner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    background: #f2f4f7;\n    font-size: 12px;\n    font-weight: 600;\n    color: #475467;\n}\n\n.pi-table-scroll {\n    overflow: auto;\n    max-height: 420px;\n}\n\n.pi-table-scroll-sm {\n    max-height: 320px;\n}\n\n.pi-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 0;\n}\n\n.pi-table th {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background: #fff;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    color: #8a94a6;\n    text-align: left;\n    padding: 10px 12px;\n    border-bottom: 1px solid #e6ebf2;\n    white-space: nowrap;\n}\n\n.pi-table td {\n    font-size: 13px;\n    color: #293241;\n    padding: 11px 12px;\n    border-bottom: 1px solid #eef1f6;\n    vertical-align: middle;\n}\n\n.pi-table tbody tr:last-child td {\n    border-bottom: 0;\n}\n\n.pi-company-link {\n    color: #2f6fed;\n    font-weight: 600;\n    text-decoration: none;\n}\n\n.pi-company-link:hover {\n    text-decoration: underline;\n}\n\n.pi-strong {\n    font-weight: 700;\n}\n\n.pi-inf-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 8px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: capitalize;\n}\n\n.pi-inf-high {\n    background: #fce8e8;\n    color: #c62828;\n}\n\n.pi-inf-med {\n    background: #fff3e0;\n    color: #e65100;\n}\n\n.pi-inf-low {\n    background: #eef1f6;\n    color: #667085;\n}\n\n.pi-sort-btn {\n    border: 0;\n    background: transparent;\n    padding: 0;\n    color: #2f6fed;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n}\n\n@media (max-width: 1200px) {\n    .pi-stat-row {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 768px) {\n    .pi-stat-row {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n    .pi-toolbar {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n.pi-rankings-grid {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 12px;\n    background: #f5f6f8;\n    border-radius: 12px;\n    padding: 12px;\n}\n\n.pi-ranking-card {\n    background: #fff;\n    border: 1px solid #e6ebf2;\n    border-radius: 10px;\n    overflow: hidden;\n    min-width: 0;\n}\n\n.pi-ranking-head {\n    padding: 10px 12px;\n    background: #eef1f6;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    color: #475467;\n    border-bottom: 1px solid #e6ebf2;\n    line-height: 1.3;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n}\n\n.pi-ranking-list {\n    list-style: none;\n    margin: 0;\n    padding: 6px 0;\n    max-height: 420px;\n    overflow-y: auto;\n}\n\n.pi-ranking-list li {\n    display: grid;\n    grid-template-columns: 28px minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 8px;\n    padding: 7px 10px;\n}\n\n.pi-rank-num {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 700;\n    color: #475467;\n    background: #eef1f6;\n}\n\n.pi-rank-gold {\n    background: #f5c542;\n    color: #5c4300;\n}\n\n.pi-rank-silver {\n    background: #c8ced6;\n    color: #3d4654;\n}\n\n.pi-rank-bronze {\n    background: #d4a574;\n    color: #5c3a1a;\n}\n\n.pi-rank-name {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 12px;\n}\n\n.pi-rank-name .pi-company-link {\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.pi-rank-value {\n    font-size: 12px;\n    font-weight: 700;\n    color: #5b8def;\n    white-space: nowrap;\n}\n\n@media (max-width: 1200px) {\n    .pi-rankings-grid {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 768px) {\n    .pi-rankings-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* —— Company Landscape (company_landscape_insights.html) —— */\n.cl-landscape.max-1250 {\n    max-width: 1250px;\n    width: 100%;\n}\n\n.cl-landscape-banner {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    background: #212529;\n    color: #fff;\n    border-radius: 0.5rem;\n    border-bottom: 4px solid #ffc107;\n    padding: 1rem 1.25rem;\n    margin-bottom: 1.5rem;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.cl-landscape-badge {\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 1.4;\n    color: #664d03;\n    background: #fff3cd;\n    border: 1px solid #ffecb5;\n    border-radius: 999px;\n    padding: 0.25rem 1rem;\n}\n\n.cl-landscape-section-title {\n    margin-bottom: 1.5rem;\n    padding-left: 0.85rem;\n    border-left: 4px solid var(--bs-primary, #0d6efd);\n}\n\n.cl-landscape-card {\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n    min-height: 148px;\n    background: #fff;\n    border: 0;\n    border-top: 4px solid var(--bs-primary, #0d6efd);\n    border-radius: 1rem;\n    padding: 1.5rem;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.cl-landscape-card--primary {\n    border-top-color: var(--bs-primary, #0d6efd);\n}\n\n.cl-landscape-card--info {\n    border-top-color: var(--bs-info, #0dcaf0);\n}\n\n.cl-landscape-card--success {\n    border-top-color: var(--bs-success, #198754);\n}\n\n.cl-landscape-card--warning {\n    border-top-color: var(--bs-warning, #ffc107);\n}\n\n.cl-landscape .display-5 {\n    font-size: 2.5rem;\n    line-height: 1.15;\n    color: #212529;\n}\n\n.cl-landscape-value-info {\n    color: #055160;\n}\n\n.cl-landscape-card-label {\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.4;\n    text-transform: uppercase;\n    color: #6c757d;\n    opacity: 0.75;\n    margin-bottom: 0;\n}\n\n.cl-landscape-hint {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 12px;\n    font-weight: 500;\n    color: #6c757d;\n}\n\n.cl-landscape-divider-vr {\n    width: 0;\n    height: calc(100% - 24px);\n    min-height: 220px;\n    border-right: 2px dashed #bebebe;\n}\n\n.cl-landscape-divider-hr {\n    width: 100%;\n    border-top: 2px dashed #bebebe;\n}\n\n.cl-landscape-relate {\n    background: #fff;\n    border: 1px solid #e9ecef;\n    border-radius: 0.5rem;\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n    font-size: 13px;\n    color: #6c757d;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.cl-landscape-num {\n    font-family: var(--bs-font-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace);\n    font-weight: 600;\n    color: var(--bs-primary, #0d6efd);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
